import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n, setLocale } from 'react-redux-i18n-lite';
import { Button, Badge } from '@netexknowledge/smart-components';
import * as guestActions from '../../actions/guestActions';
import { getGuestProfileFromStorage, getGuestSessionFromStorage, languageStorageHandler } from '../../shared';
import { GUEST_LANGUAGES } from '../../const';
import { setDayJsLocale } from '../../services/translate/dayjsLocaleUpdater';
import LanguageSelector from '../user/profile/LanguageSelector';
import * as analyticsApi from '../../services/api/analyticsApi';
import { ANALYTICS_EVENT, ANALYTICS_CONTEXT } from '../../types/analytics';
import GuestRequestAccountModal from './GuestRequestAccountModal';

class GuestTopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { requestAccountModalOpen: false };
    this.openRequestAccountModal = this.openRequestAccountModal.bind(this);
    this.closeRequestAccountModal = this.closeRequestAccountModal.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);
  }

  static propTypes = {
    clientName: PropTypes.string,
    locale: PropTypes.string,
    guestActions: PropTypes.object,
    setLocale: PropTypes.func
  };

  openRequestAccountModal() {
    const session = getGuestSessionFromStorage();
    const profile = getGuestProfileFromStorage();
    analyticsApi.trackAnalyticsEvent({
      event: ANALYTICS_EVENT.GUEST_REQUEST_ACCOUNT,
      context: ANALYTICS_CONTEXT.GUEST_REQUEST_ACCOUNT_BUTTON,
      clientId: session && session.clientId,
      schoolId: session && session.schoolId,
      clientName: session && session.clientName,
      name: profile.name,
      email: profile.email
    });
    this.setState({ requestAccountModalOpen: true });
  }

  closeRequestAccountModal() {
    this.setState({ requestAccountModalOpen: false });
  }

  changeLanguage(language) {
    languageStorageHandler(language);
    setDayJsLocale(language);
    this.props.setLocale(language);
  }

  render() {
    const { clientName, locale, guestActions } = this.props;
    const { requestAccountModalOpen } = this.state;
    const profile = getGuestProfileFromStorage();

    return (
      <div className="guest-top-bar">
        <div className="guest-top-bar-row">
          <div className="guest-top-bar-identity">
            <span className="guest-top-bar-client-name">{clientName}</span>
            <Badge label={I18n.t('guest.catalog.badge')} className="guest-badge" />
          </div>
          <div className="guest-top-bar-actions">
            <div className="guest-language-selector">
              <LanguageSelector languages={GUEST_LANGUAGES} selected={locale} updateLanguage={this.changeLanguage} />
            </div>
            <Button
              id="guest-request-account-link"
              className="guest-request-account-button"
              label={I18n.t('guest.catalog.requestAccount')}
              onClick={this.openRequestAccountModal}
            />
            <Button
              id="guest-exit-button"
              className="guest-exit-button"
              label={I18n.t('guest.catalog.exit')}
              onClick={() => guestActions.exitGuestSession()}
            />
          </div>
        </div>
        <div className="guest-top-bar-row guest-top-bar-tabs">
          <span className="guest-tab">{I18n.t('guest.catalog.tab')}</span>
        </div>
        <GuestRequestAccountModal
          active={requestAccountModalOpen}
          onClose={this.closeRequestAccountModal}
          clientName={clientName}
          name={profile.name}
          email={profile.email}
        />
      </div>
    );
  }
}

// locale se mapea también para que la cabecera se repinte con los textos del nuevo idioma al cambiarlo.
function mapStateToProps(state) {
  return {
    locale: state.i18n.locale
  };
}

function mapDispatchToProps(dispatch) {
  return {
    guestActions: bindActionCreators(guestActions, dispatch),
    setLocale: bindActionCreators(setLocale, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestTopBar);
